function InnerBanner(props) {
    return (
        <>
            <div className="innerBanner">
                <img src={process.env.PUBLIC_URL + "/images/" + props.img_url} alt=""/>
                <div className="content">
                    <h1 data-aos='fade-in'>
                        {props.heading}
                    </h1>
                    {props?.isDescription && (
                        <p data-aos='fade-in' data-aos-delay='100'>{props.description}</p>
                    )}
                </div>
            </div>
        </>
    )
}

export default InnerBanner